import {HttpModelConverter} from "../../../modules/core/converter/httpModel.converter";
import {Page} from "../../../shared/model/core/page.model";

export class PageHelperV2 {

    public static convertRestPageToStorePage(restPage: any, converter?: HttpModelConverter<any>): Page<any> {
        // // console.logByType['restPage', restPage])
        const entities = restPage.content.map(value => converter ? converter.convert(value) : value);
        const page = new Page();
        page.size = restPage.size;
        page.last = restPage.last;
        page.first = restPage.first;
        page.number = restPage.number;
        page.totalElements = restPage.totalElements;
        page.numberOfElements = restPage.numberOfElements;
        page.totalPages = restPage.totalPages;
        page.pageable = restPage.pageable;
        page.content = entities;
        /*const restPageContent: [] = restPage.content;
        entities.currentPageItemIndexes$ =  restPageContent.map((value: any) => {
            // FIXME Not right!It should reuse EntityMetadataMap.selectId function. But I don't know how to do it.
            if (value?.summary?.id) {
                return value.summary.id;
            } else {
                return value.id;
            }
        })
        // console.logByType['entities', entities]); */
        return page;
    }
}
